/**
 * シーン定数
 *
 * 状態遷移図:
 *
 *                           TOP
 *                            │
 *        ┌───────────────────┤
 *        ▼                   ▼
 *  PayoutRequestTop     HarvestTop
 *        │                   │
 *    ┌───┼───┐           ┌───┴───┐
 *    ▼       ▼           ▼       ▼
 * History Confirm   History  EstimatedReturn
 *
 * ※ 再投資（Reinvestment）はファームチケット画面へ外部遷移
 */
export const Scenes = {
  TOP: "top",

  PAYOUT_REQUEST_TOP: "payout_request_top",
  PAYOUT_REQUEST_CONFIRM: "payout_request_confirm",
  PAYOUT_REQUEST_HISTORY: "payout_request_history",

  HARVEST_TOP: "harvest_top",
  HARVEST_HISTORY: "harvest_history",
  HARVEST_ESTIMATED_RETURN: "harvest_estimated_return",

  REINVESTMENT: "reinvestment",
};

/** キャラクター名 */
export const CHARACTER_NAME = "オーウェン";

/** 会話テキストアニメーション速度（1文字あたりのミリ秒） */
export const MS_PER_CHAR = 40;

/**
 * 通知タイプ定数
 * API呼び出し後の結果通知（成功・エラー）に使用
 */
export const NotificationTypes = {
  PAYOUT_REQUEST_TOP_MIN_ERROR: "payout_request_top_min_error",
  PAYOUT_REQUEST_TOP_MAX_ERROR: "payout_request_top_max_error",
  PAYOUT_REQUEST_CONFIRM_SUBMIT_SUCCESS: "payout_request_confirm_submit_success",
  PAYOUT_REQUEST_CONFIRM_SUBMIT_ERROR: "payout_request_confirm_submit_error",
};
